{
  "login_providers.title": "第三方登录配置",
  "login_providers.description": "集中维护可复用的平台登录凭据，预检通过并启用后，再由每个 App 原子选择需要开放的平台。",
  "login_providers.empty": "暂无第三方登录配置",
  "login_providers.binding_count": "已绑定 {count} 个 App",
  "login_providers.provider.wechat": "微信",
  "login_providers.provider.github": "GitHub",
  "login_providers.provider.apple": "Apple",
  "login_providers.provider.google": "Google",
  "login_providers.platform.android": "Android",
  "login_providers.platform.ios": "iOS",
  "login_providers.platform.harmony": "HarmonyOS",
  "login_providers.build_variant.android_google": "Android Google 版",
  "login_providers.build_variant.android_china": "Android 国内版",
  "login_providers.build_variant.ios": "iOS 版",
  "login_providers.build_variant.harmony": "HarmonyOS 版",
  "login_providers.status.draft": "草稿",
  "login_providers.status.active": "已启用",
  "login_providers.status.disabled": "已停用",
  "login_providers.preflight.not_run": "未预检",
  "login_providers.preflight.ready": "预检通过",
  "login_providers.preflight.failed": "预检失败",
  "login_providers.actions.create": "新建平台配置",
  "login_providers.actions.rotate_secret": "更新密钥",
  "login_providers.actions.preflight": "执行预检",
  "login_providers.actions.activate": "启用",
  "login_providers.actions.disable": "停用",
  "login_providers.actions.delete": "删除配置",
  "login_providers.columns.name": "配置名称",
  "login_providers.columns.provider": "平台",
  "login_providers.columns.client_id": "平台客户端标识",
  "login_providers.columns.status": "状态",
  "login_providers.columns.preflight": "预检",
  "login_providers.columns.bindings": "已绑定 App",
  "login_providers.columns.updated_at": "更新时间",
  "login_providers.columns.actions": "操作",
  "login_providers.filters.query": "搜索配置名称或平台客户端标识",
  "login_providers.filters.provider": "平台",
  "login_providers.filters.status": "状态",
  "login_providers.security.title": "密钥仅写入服务端",
  "login_providers.security.description": "AppSecret、Client Secret 和 Apple 私钥不会回显、不会进入 App 配置或日志；更新密钥使用独立的一次性表单。",
  "login_providers.editor.create_title": "新建第三方登录配置",
  "login_providers.editor.edit_title": "编辑第三方登录配置",
  "login_providers.editor.basic": "基本信息",
  "login_providers.editor.provider_fields": "平台与原生工程信息",
  "login_providers.editor.secret_title": "密钥已与基础配置分离",
  "login_providers.editor.secret_description": "如需新增或轮换密钥，请关闭编辑抽屉后使用列表中的“更新密钥”；现有值永不回显。",
  "login_providers.field.name": "配置名称",
  "login_providers.field.description": "配置说明",
  "login_providers.field.provider": "登录平台",
  "login_providers.field.wechat_app_id": "微信 AppID",
  "login_providers.field.app_secret": "AppSecret",
  "login_providers.field.client_id": "GitHub Client ID",
  "login_providers.field.client_secret": "GitHub Client Secret",
  "login_providers.field.apple_client_id": "Apple Client ID / Bundle ID",
  "login_providers.field.server_client_id": "Google 服务端 Web Client ID",
  "login_providers.field.android_package_name": "Android 包名",
  "login_providers.field.android_app_signature": "Android 应用签名",
  "login_providers.field.ios_bundle_id": "iOS Bundle ID",
  "login_providers.field.ios_universal_link": "iOS Universal Link",
  "login_providers.field.harmony_bundle_name": "HarmonyOS Bundle Name",
  "login_providers.field.app_return_uri": "App 回跳 HTTPS 地址",
  "login_providers.field.callback_uri": "平台授权回调地址",
  "login_providers.field.team_id": "Apple Team ID",
  "login_providers.field.key_id": "Apple Key ID",
  "login_providers.field.private_key_p8": "Apple 私钥（.p8）",
  "login_providers.field.android_certificate_sha256": "Android 证书 SHA-256 指纹",
  "login_providers.field_help.wechat_app_id": "微信开放平台移动应用的 AppID，格式为 wx 加 16 位字符。",
  "login_providers.field_help.github_client_id": "GitHub OAuth App 的公开 Client ID。",
  "login_providers.field_help.apple_client_id": "原生 iOS 登录使用启用 Sign in with Apple 的 Bundle ID。",
  "login_providers.field_help.server_client_id": "必须填写 Google Cloud 创建的 Web OAuth Client ID，用作服务端 ID Token audience；不是 Android Client ID。",
  "login_providers.field_help.android_package_name": "须与发布包及第三方控制台登记的 Android applicationId 完全一致。",
  "login_providers.field_help.android_app_signature": "填写微信开放平台要求的正式包应用签名。",
  "login_providers.field_help.ios_bundle_id": "须与 Apple 开发者后台和原生工程的 Bundle ID 一致。",
  "login_providers.field_help.ios_universal_link": "填写已验证、以 HTTPS 开头且与微信开放平台登记一致的 Universal Link。",
  "login_providers.field_help.harmony_bundle_name": "须与 HarmonyOS 工程和微信开放平台登记的 Bundle Name 一致。",
  "login_providers.field_help.app_return_uri": "平台回调由服务端接收后，通过此受控 HTTPS 地址把一次性 App ticket 交回客户端。",
  "login_providers.field_help.team_id": "Apple Developer 团队的 10 位 Team ID。",
  "login_providers.field_help.key_id": "启用 Sign in with Apple 的 10 位私钥 Key ID。",
  "login_providers.field_help.android_certificate_sha256": "每行一个以冒号分隔的 SHA-256 证书指纹，可同时登记正式包和测试包。",
  "login_providers.field_help.app_secret": "仅发送给服务端加密保存，保存后永不回显。",
  "login_providers.field_help.client_secret": "仅发送给服务端用于 GitHub code 交换，保存后永不回显。",
  "login_providers.field_help.private_key_p8": "粘贴 Apple 下载的一次性 .p8 私钥完整内容；仅服务端加密保存。",
  "login_providers.placeholders.one_per_line": "每行填写一个值",
  "login_providers.validation.name": "请输入 1–160 个字符的配置名称。",
  "login_providers.validation.description": "配置说明不能超过 2000 个字符。",
  "login_providers.validation.external_client_id": "请输入有效的平台客户端标识。",
  "login_providers.validation.wechat_app_id": "请输入以 wx 开头的 18 位微信 AppID。",
  "login_providers.validation.apple_client_id": "请输入有效的 Apple Bundle ID。",
  "login_providers.validation.server_client_id": "请输入以 .apps.googleusercontent.com 结尾的服务端 Web Client ID。",
  "login_providers.validation.required": "此字段为必填项。",
  "login_providers.validation.max_length": "输入内容超过允许长度。",
  "login_providers.validation.https_url": "请输入绝对 HTTPS 地址。",
  "login_providers.validation.android_package_name": "请输入有效的 Android 包名。",
  "login_providers.validation.ios_bundle_id": "请输入有效的 iOS Bundle ID。",
  "login_providers.validation.wechat_android_pair": "Android 包名与应用签名必须同时填写或同时留空。",
  "login_providers.validation.wechat_ios_pair": "iOS Bundle ID 与 Universal Link 必须同时填写或同时留空。",
  "login_providers.validation.team_id": "请输入 10 位大写字母或数字的 Apple Team ID。",
  "login_providers.validation.key_id": "请输入 10 位大写字母或数字的 Apple Key ID。",
  "login_providers.validation.android_certificate_sha256": "请输入以冒号分隔的完整 SHA-256 证书指纹。",
  "login_providers.validation.private_key_p8": "请输入完整的 PKCS#8 PRIVATE KEY PEM 内容。",
  "login_providers.feedback.saved": "第三方登录配置已保存。",
  "login_providers.feedback.secret_rotated": "平台密钥已安全更新。",
  "login_providers.feedback.preflight": "预检已完成，请查看最新结果。",
  "login_providers.feedback.activate": "平台配置已启用。",
  "login_providers.feedback.disable": "平台配置已停用。",
  "login_providers.feedback.deleted": "平台配置已删除。",
  "login_providers.feedback.error": "操作失败，请检查输入、平台状态和权限后重试。",
  "login_providers.feedback.conflict": "配置已被其他管理员更新，请刷新最新数据后重新确认。",
  "login_providers.feedback.conflict_description": "刷新只更新并发版本和只读元数据；当前表单输入会保留，不会自动覆盖或重提。",
  "login_providers.feedback.conflict_refreshed": "已刷新并发版本，当前编辑内容已保留；请重新核对后保存。",
  "login_providers.feedback.conflict_refresh_error": "无法读取最新配置，当前编辑内容仍保留，请稍后重试。",
  "login_providers.feedback.load_error": "无法加载第三方登录配置。",
  "login_providers.feedback.catalog_mismatch": "服务端平台目录与当前 Admin 版本不兼容",
  "login_providers.feedback.catalog_mismatch_description": "为避免写入未知字段，当前页面已停止编辑和绑定。请升级到与服务端能力目录匹配的 Admin 版本。",
  "login_providers.confirm.activate": "启用“{name}”后，已选择此配置的 App 才可能下发该平台；运行时仍要求绑定开启且预检通过。",
  "login_providers.confirm.disable": "停用“{name}”会让其 {count} 个 App 绑定立即失败关闭，客户端不再展示该登录入口。",
  "login_providers.confirm.delete": "确定删除“{name}”吗？仅未被任何 App 使用的配置可以删除。",
  "login_providers.unsaved.title": "放弃未保存的修改？",
  "login_providers.unsaved.description": "关闭后，当前平台配置中尚未保存的修改会丢失。",
  "login_providers.unsaved.discard": "放弃修改",
  "login_providers.secret.title": "更新 {provider} 密钥",
  "login_providers.secret.write_only": "现有密钥不会回显",
  "login_providers.secret.description": "本次提交会替换所填密钥。关闭窗口会立即清空浏览器中的明文输入。",
  "login_providers.binding.title": "按 App 开启第三方登录",
  "login_providers.binding.description": "每个平台只能选择同租户、已启用且预检通过的配置。四个平台通过一次原子请求保存，任一冲突都不会部分生效。",
  "login_providers.binding.config": "平台配置",
  "login_providers.binding.select_config": "选择可用配置",
  "login_providers.binding.config_for_provider": "{provider} 平台配置",
  "login_providers.binding.enable_provider": "开启 {provider} 登录",
  "login_providers.binding.config_required": "开启前必须选择一个可用配置。",
  "login_providers.binding.no_active_config": "没有已启用且预检通过的配置",
  "login_providers.binding.open_configs": "打开配置管理",
  "login_providers.binding.provider_unavailable": "当前 Admin 与服务端的平台能力不匹配，此平台已锁定。",
  "login_providers.binding.unavailable": "当前配置不可用",
  "login_providers.binding.runtime_fail_closed": "该绑定引用的配置已停用或预检失效，运行时不会展示或接受此平台登录。请选择新的可用配置后保存。",
  "login_providers.binding.ready": "此平台满足后台下发条件",
  "login_providers.binding.rebuild_required": "平台身份还必须写入对应原生构建配置；后台保存不会自动改变已安装 App。",
  "login_providers.binding.saved": "第三方登录配置已原子保存。",
  "login_providers.binding.validation": "请为每个已开启的平台选择有效配置。",
  "login_providers.binding.load_error": "无法加载 App 的第三方登录配置。",
  "login_providers.binding.conflict": "至少一项配置已被其他管理员修改；本次请求没有部分生效，请刷新后重新确认。",
  "login_providers.binding.conflict_description": "刷新只合并四个平台的最新并发版本；当前选择、开关和排序会保留，不会自动重提。",
  "login_providers.binding.conflict_refreshed": "已刷新并发版本，四个平台的本地修改已保留；请重新核对后保存。",
  "login_providers.binding.conflict_refresh_error": "无法读取最新绑定，并未丢失本地修改，请稍后重试。",
  "login_providers.guide.trigger": "查看第三方登录申请与接入指引",
  "login_providers.guide.title": "第三方登录平台申请指引",
  "login_providers.guide.verified": "按平台逐项核对",
  "login_providers.guide.intro": "先准备正式包的应用标识和签名，再到平台控制台申请。平台规则可能调整，请在提交前通过下方官方链接复核。",
  "login_providers.guide.actions.close": "完成阅读",
  "login_providers.guide.sections.application": "申请步骤",
  "login_providers.guide.sections.fields": "后台字段对应关系",
  "login_providers.guide.sections.before_save": "保存前检查",
  "login_providers.guide.sections.official_resources": "官方资源",
  "login_providers.guide.provider.wechat.summary": "适用于 Android、iOS 与 HarmonyOS 原生微信授权，客户端只提交一次性 code。",
  "login_providers.guide.provider.wechat.account_type": "微信开放平台认证账号",
  "login_providers.guide.provider.wechat.step.1.title": "注册并认证开发者主体",
  "login_providers.guide.provider.wechat.step.1.description": "登录微信开放平台，使用拥有应用发布权的组织主体完成开发者资质认证。",
  "login_providers.guide.provider.wechat.step.2.title": "创建移动应用",
  "login_providers.guide.provider.wechat.step.2.description": "提交应用资料，并准确登记正式包的 Android 包名与签名、iOS Bundle ID 与 Universal Link、HarmonyOS Bundle Name。",
  "login_providers.guide.provider.wechat.step.3.title": "取得 AppID 与 AppSecret",
  "login_providers.guide.provider.wechat.step.3.description": "审核通过后复制 AppID；AppSecret 只粘贴到独立密钥窗口，不写入客户端工程。",
  "login_providers.guide.provider.wechat.step.4.title": "配置原生能力并预检",
  "login_providers.guide.provider.wechat.step.4.description": "在实际构建变体启用微信 OAuth，重新导出打包，再执行后台预检。",
  "login_providers.guide.provider.wechat.field.wechat_app_id": "平台审核通过后签发的移动应用 AppID。",
  "login_providers.guide.provider.wechat.field.app_secret": "仅服务端用于一次性 code 交换，永不下发给 App。",
  "login_providers.guide.provider.wechat.field.android_package_name": "与正式 Android applicationId 完全一致。",
  "login_providers.guide.provider.wechat.field.android_app_signature": "与微信开放平台登记的正式包签名一致。",
  "login_providers.guide.provider.wechat.field.ios_bundle_id": "与 iOS 工程和开放平台登记值一致。",
  "login_providers.guide.provider.wechat.field.ios_universal_link": "已部署关联文件并在开放平台登记的 HTTPS Universal Link。",
  "login_providers.guide.provider.wechat.field.harmony_bundle_name": "与 HarmonyOS 工程和开放平台登记值一致。",
  "login_providers.guide.provider.wechat.note": "AppID 需要进入原生包；AppSecret、access token 与 refresh token 只允许留在服务端。",
  "login_providers.guide.provider.wechat.link.platform": "微信开放平台",
  "login_providers.guide.provider.wechat.link.dcloud": "uni-app x 登录文档",
  "login_providers.guide.provider.github.summary": "适用于 Android、iOS 与 HarmonyOS 的系统浏览器 OAuth，服务端接收回调并向 App 签发一次性 ticket。",
  "login_providers.guide.provider.github.account_type": "GitHub 个人或组织账号",
  "login_providers.guide.provider.github.step.1.title": "选择 OAuth App 所属账号",
  "login_providers.guide.provider.github.step.1.description": "使用长期维护的 GitHub 组织或个人账号进入 Developer settings。",
  "login_providers.guide.provider.github.step.2.title": "创建 OAuth App",
  "login_providers.guide.provider.github.step.2.description": "填写产品名称、主页和后台只读展示的精确 Authorization callback URL。",
  "login_providers.guide.provider.github.step.3.title": "保存 Client ID 与 Client Secret",
  "login_providers.guide.provider.github.step.3.description": "Client ID 写入基础配置；Client Secret 只通过独立密钥窗口提交给服务端。",
  "login_providers.guide.provider.github.step.4.title": "配置 App 回跳并预检",
  "login_providers.guide.provider.github.step.4.description": "提供 allowlist 内的 HTTPS App 回跳地址，确认 Universal/App Link 后执行预检。",
  "login_providers.guide.provider.github.field.client_id": "GitHub OAuth App 的公开 Client ID。",
  "login_providers.guide.provider.github.field.client_secret": "仅服务端用于授权码交换，永不进入 App。",
  "login_providers.guide.provider.github.field.app_return_uri": "服务端完成交换后把一次性 ticket 交回 App 的 HTTPS 地址。",
  "login_providers.guide.provider.github.field.callback_uri": "由服务端部署基址计算；须原样登记到 GitHub，不可在后台修改。",
  "login_providers.guide.provider.github.note": "授权必须使用 state 与 PKCE S256；scope 保持最小化，Secret 不得写入移动端。",
  "login_providers.guide.provider.github.link.apps": "GitHub Developer settings",
  "login_providers.guide.provider.github.link.oauth": "GitHub OAuth 授权文档",
  "login_providers.guide.provider.apple.summary": "仅适用于 iOS 原生 Sign in with Apple，服务端校验 ID Token，并保留授权码撤销能力。",
  "login_providers.guide.provider.apple.account_type": "Apple Developer 账号",
  "login_providers.guide.provider.apple.step.1.title": "为 App ID 开启 Apple 登录",
  "login_providers.guide.provider.apple.step.1.description": "在 Certificates, Identifiers & Profiles 中为正式 Bundle ID 启用 Sign in with Apple。",
  "login_providers.guide.provider.apple.step.2.title": "创建 Sign in with Apple 私钥",
  "login_providers.guide.provider.apple.step.2.description": "创建启用 Apple 登录的 Key，记录 Team ID 与 Key ID，并立即安全保存一次性下载的 .p8 文件。",
  "login_providers.guide.provider.apple.step.3.title": "填写标识与私钥",
  "login_providers.guide.provider.apple.step.3.description": "基础配置填写 Bundle ID、Team ID 和 Key ID；私钥仅通过独立密钥窗口提交。",
  "login_providers.guide.provider.apple.step.4.title": "配置 entitlement 并预检",
  "login_providers.guide.provider.apple.step.4.description": "在 iOS 工程启用 Sign in with Apple capability，重新签名打包后执行预检。",
  "login_providers.guide.provider.apple.field.apple_client_id": "原生 iOS 场景使用启用 Apple 登录的 Bundle ID。",
  "login_providers.guide.provider.apple.field.team_id": "Apple Developer Membership 中的 10 位 Team ID。",
  "login_providers.guide.provider.apple.field.key_id": "新建 Apple 登录 Key 后显示的 10 位 Key ID。",
  "login_providers.guide.provider.apple.field.private_key_p8": "一次性下载的完整 .p8 私钥，仅服务端用于生成 client secret。",
  "login_providers.guide.provider.apple.note": "Apple 用户姓名通常只在首次授权返回；客户端不得持久化或转发 Apple 私钥。",
  "login_providers.guide.provider.apple.link.account": "Apple Keys 管理",
  "login_providers.guide.provider.apple.link.signin": "Sign in with Apple 入门",
  "login_providers.guide.provider.google.summary": "仅适用于 Android Google 版，通过 Credential Manager 获取 ID Token 并由服务端校验 audience。",
  "login_providers.guide.provider.google.account_type": "Google Cloud 项目管理员",
  "login_providers.guide.provider.google.step.1.title": "配置 Google Cloud 项目与同意屏幕",
  "login_providers.guide.provider.google.step.1.description": "在 Google Cloud Console 选择长期维护的项目，配置 OAuth consent screen 和所需发布状态。",
  "login_providers.guide.provider.google.step.2.title": "创建 Android 与 Web OAuth 客户端",
  "login_providers.guide.provider.google.step.2.description": "Android 客户端登记包名与 SHA-256；另建 Web 客户端，供服务端作为 ID Token audience。",
  "login_providers.guide.provider.google.step.3.title": "填写服务端 Client ID",
  "login_providers.guide.provider.google.step.3.description": "复制 Web OAuth Client ID 到本页面，不要填写 Android Client ID，也不需要 Client Secret。",
  "login_providers.guide.provider.google.step.4.title": "集成 Credential Manager 并预检",
  "login_providers.guide.provider.google.step.4.description": "仅在 Android Google 构建变体集成 Google ID provider，重新打包后执行预检。",
  "login_providers.guide.provider.google.field.server_client_id": "Web OAuth Client ID；服务端用它校验 ID Token aud。",
  "login_providers.guide.provider.google.field.android_package_name": "与 Google Console 登记和 Android Google 版 applicationId 一致。",
  "login_providers.guide.provider.google.field.android_certificate_sha256": "登记每个实际签名证书的完整 SHA-256 指纹。",
  "login_providers.guide.provider.google.note": "Google 登录不进入 Android 国内版；不要把 FCM service account 或 Android Client ID 当成登录凭据。",
  "login_providers.guide.provider.google.link.console": "Google Cloud 凭据管理",
  "login_providers.guide.provider.google.link.credential_manager": "Credential Manager 登录文档"
}
